<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-select v-model="filters.type" placeholder="请选择类型" @change="handleSearchTypeChange">
						<el-option label="歌单名" value="name" ></el-option>
						<el-option label="用户ID" value="userId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" :placeholder="placeholder"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="fetch">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="recordList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="name" label="名称" width="200">
				<template slot-scope="scope">
					<a @click="gotoAlbumMusic(scope.row)" target="_blank" class="buttonText">{{scope.row.name}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="username" label="所有者" width="200">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="gotoAlbumMusic(scope.row)">歌曲列表</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :page-count="pageNo" :total="pageTotal" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="歌单名" prop="name">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="用户" prop="userId">
					<el-autocomplete
						class="el-input"
						v-model="editForm.username"
						:fetch-suggestions="searchUser"
						placeholder="请输入用户名"
						:trigger-on-focus="false"
						@select="handleSelect">
					</el-autocomplete>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="歌单名" prop="name">
					<el-input v-model="addForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="用户" prop="userId">
					<el-autocomplete
						class="el-input"
						v-model="addForm.username"
						:fetch-suggestions="searchUser"
						placeholder="请输入用户名"
						:trigger-on-focus="false"
						@select="handleSelect">
					</el-autocomplete>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getUserList, getAlbumListPage, removeAlbum, batchRemoveAlbum, editAlbum, addAlbum } from '../api/api';

	export default {
		data() {
			return {
				filters: {
					type: this.$route.query.userId ? 'userId' : 'name',
					name: this.$route.query.userId ||'',
				},
				placeholder: this.$route.query.userId ? '用户ID' : '歌单名称',
				recordList: [],
				pageTotal: 0,
				currentPage: 1,
				pageSize: 15,
				pageNo: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入歌手名', trigger: 'blur' }
					],
					userId: [
						{ required: true, message: '请选择用户', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					userId: '',
					username: '',
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入歌手名', trigger: 'blur' }
					],
					userId: [
						{ required: true, message: '请选择用户', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					userId: '',
					username: '',
				}

			}
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetch();
			},
			gotoAlbumMusic: function(album) {
				this.$router.push({
					path: '/albumMusic', 
					query: {
						albumId: album._id,
						userId: album.userId,
						title: album.name,
						username: album.username,
					}
				})
			},
			//获取用户列表
			async fetch() {
				let para = {
					type: this.filters.type,
					name: this.filters.name,
					currentPage: this.currentPage,
					pageSize: this.pageSize,
				};
				this.listLoading = true;
				//NProgress.start();
				const res = await getAlbumListPage(para)
				this.listLoading = false;
				//NProgress.done();
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'warning'
					});
					return
				}
				this.currentPage = res.data.data.currentPage;
				this.pageSize = res.data.data.pageSize;
				this.pageNo = res.data.data.pageNo;
				this.pageTotal = res.data.data.pageTotal;
				this.recordList = res.data.data.recordList;
			},
			async searchUser(name, callback) {
				const res = await getUserList({ name })
				callback(res.data.data.recordList.map(item => {
					return { ...item, value: item.name };
				}))
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					userId: (this.filters.type === 'userId' && this.filters.name) ? this.$route.query.userId : '',
					username: (this.filters.type === 'userId' && this.filters.name) ? this.$route.query.username : '',
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate(async (valid) => {
					if (valid) {
						this.editLoading = true;
						//NProgress.start();
						const para = Object.assign({}, this.editForm);
						const res = await editAlbum(para)
						this.editLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['editForm'].resetFields();
						this.editFormVisible = false;
						this.fetch();
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						this.addLoading = true;
						//NProgress.start();
						let para = Object.assign({}, this.addForm);
						const res = await addAlbum(para)
						this.addLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['addForm'].resetFields();
						this.addFormVisible = false;
						this.fetch();
					}
				});
			},
			handleSelect(item) {
				if (this.addFormVisible) {
					this.addForm.userId = item._id
				} else if (this.editFormVisible) {
					this.editForm.userId = item._id
				}
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					const para = { id: row._id };
					const res = await removeAlbum(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			},
			handleSearchTypeChange(value) {
				if (value === 'name') {
					this.placeholder = '歌单名称'
					this.filters.name = ''
					this.fetch()
				} else {
					this.placeholder = '用户ID'
					this.filters.name = ''
				}
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				const ids = this.sels.map(item => item._id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					const res = await batchRemoveAlbum(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.fetch();
		}
	}

</script>

<style lang="scss" scoped>
.buttonText{
	cursor: pointer;
	text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// Album.vue?136619ac